import PropTypes from 'prop-types';
import { ModalGeneric } from 'ypf-pas-general-ui-components';
import { Col, Row } from 'react-bootstrap';

import HeaderDetail from '../../Wells/HeaderDetail/HeaderDetail';

const ReplaceLinesSuccessModal = (props) => {
  const { reemplazoDeLinea, onHide } = props;

  return (
    <ModalGeneric
      backdrop="static"
      infoModal
      onHide={onHide}
      onSubmit={onHide}
      primaryAction={onHide}
      primaryActionLabel="Entendido"
      show
      size="xl"
      title="Aviso"
    >
      <div className="fs-6 fw-semibold ">
        <p className="d-flex flex-column ">
          <span>{reemplazoDeLinea?.titulo} </span>
          <span>{reemplazoDeLinea?.cuerpo} </span>
          <span>Las siguientes Posiciones y Líneas fueron reemplazadas:</span>
        </p>
      </div>
      {Array.isArray(reemplazoDeLinea?.posicionLineas) ? (
        <div className="ps-5 d-flex flex-column border-start border-5 border-dark py-4">
          <Row className="fw-bold">
            <Col>Posición</Col>
            <Col>Línea</Col>
          </Row>
          {reemplazoDeLinea.posicionLineas.map((item, i) => (
            <>
              {i > 0 && <Row className="border-top w-70 mx-auto py-6" />}
              <Row className="text-muted" style={{ backgroundColor: '#F8F8F8' }}>
                <Col className="py-2 ">{item.posicion}</Col>
                <Col className="py-2">{item.linea}</Col>
              </Row>
              <Row className="fw-bold">
                <Col className="py-2">{item.posicionVinculada}</Col>
                <Col className="py-2">{item.lineaVinculada}</Col>
              </Row>
            </>
          ))}
        </div>
      ) : (
        reemplazoDeLinea?.ubicaciones?.map((ubicacion) => (
          <>
            <HeaderDetail
              data={{
                well: { label: ubicacion?.pozo },
                event: { sigla: ubicacion?.evento, nombre: ubicacion?.evento },
                team: { label: ubicacion?.equipo }
              }}
              disabledDeleteWell
            />
            <div
              className="ps-5 mb-4 d-flex flex-column border-start border-5 border-dark py-4"
              key={`${ubicacion.pozo}-${ubicacion.evento}-${ubicacion.equipo}`}
            >
              <Row className="fw-bold">
                <Col>Posición</Col>
                <Col>Línea</Col>
              </Row>
              {ubicacion.posicionLineas?.map((item, i) => (
                <>
                  {i > 0 && <Row className="border-top w-70 mx-auto py-6" />}
                  <Row className="text-muted" style={{ backgroundColor: '#F8F8F8' }}>
                    <Col className="py-2">{item.posicion}</Col>
                    <Col className="py-2">{item.linea}</Col>
                  </Row>
                  <Row className="fw-bold">
                    <Col className="py-2">{item.posicionVinculada}</Col>
                    <Col className="py-2">{item.lineaVinculada}</Col>
                  </Row>
                </>
              ))}
            </div>
          </>
        ))
      )}
    </ModalGeneric>
  );
};

ReplaceLinesSuccessModal.propTypes = {
  onHide: PropTypes.func.isRequired,
  reemplazoDeLinea: PropTypes.shape({
    titulo: PropTypes.string.isRequired,
    cuerpo: PropTypes.string.isRequired,
    aplicado: PropTypes.bool,
    validoParaAplicar: PropTypes.bool,
    cantidadesEnviadas: PropTypes.bool,
    posicionesYLineasCargadas: PropTypes.bool,
    hayPosicionesLineasReemplazadas: PropTypes.bool,
    ubicaciones: PropTypes.arrayOf(
      PropTypes.shape({
        pozo: PropTypes.string,
        evento: PropTypes.string,
        equipo: PropTypes.string,
        posicionLineas: PropTypes.arrayOf(
          PropTypes.shape({
            posicion: PropTypes.string,
            linea: PropTypes.string,
            posicionVinculada: PropTypes.string,
            lineaVinculada: PropTypes.string
          })
        )
      })
    ),
    posicionLineas: PropTypes.oneOfType([
      PropTypes.arrayOf(
        PropTypes.shape({
          posicion: PropTypes.string,
          linea: PropTypes.string,
          posicionVinculada: PropTypes.string,
          lineaVinculada: PropTypes.string
        })
      ),
      PropTypes.oneOf([null])
    ]),
    tieneUbicaciones: PropTypes.bool,
    tienePosicionLineas: PropTypes.bool
  }).isRequired
};
export default ReplaceLinesSuccessModal;
